module.exports = __webpack_public_path__ + "static/media/golfer-7-b.df46012a.png";